if (!customElements.get('adev-related-products')) {
    customElements.define('adev-related-products', class adevRelatedProducts extends HTMLElement {
        constructor() {
            super();
        }

        fetchProducts() {
            const htmlEl = this.querySelector('[data-adev-related-products="html"]');
            const url = htmlEl.getAttribute('data-url');
            const sectionId = htmlEl.getAttribute('data-section-id');
            const productId = htmlEl.getAttribute('data-product-id');

            const fetchUrl = `${url}&product_id=${productId}&section_id=${sectionId}`;

            fetch(fetchUrl)
                .then(response => response.text())
                .then(data => {
                    this.renderProducts(data);
                })
                .catch(error => {
                    console.error('Error fetching products:', error);
                });
        }

        renderProducts(data) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data, 'text/html');
            const docHtmlEl = doc.querySelector('[data-adev-related-products="html"]');
            const htmlEl = this.querySelector('[data-adev-related-products="html"]');

            htmlEl.innerHTML = docHtmlEl.innerHTML;

            this.classList.add('adev--is-ready');
        }

        connectedCallback() {
            this._observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        this.fetchProducts();
                        observer.unobserve(this);
                    }
                });
            }, {
                root: null,
                rootMargin: '200px',
                threshold: 0
            });
            this._observer.observe(this);
        }

        disconnectedCallback() {
            if (this._observer) {
                this._observer.disconnect();
            }
        }

    });
}